/**
 * 選択式診断機能
 * @param {string} className 診断コンポーネントのクラス名
 */
export function diagnosis(className) {
	// 選択肢ボタンの取得
	const diagnosisButtons = document.querySelectorAll(`.${className}-select li`);

	// 選択肢ボタンが存在しない場合は処理を終了
	if (!diagnosisButtons.length) return;

	diagnosisButtons.forEach(button => {
		// 選択肢ボタンクリック時に発火
		button.addEventListener('click', () => {
			// 親要素を取得
			const parent = button.closest(`.${className}`);
			if (!parent) return;

			// 全てのアイテムを非表示
			const items = parent.querySelectorAll(`.${className}-item`);
			items.forEach(item => {
				item.classList.remove(`${className}-active`);
			});

			// 表示するアイテムを取得し表示
			const nextItemId = button.getAttribute('data-select');
			const nextItem = parent.querySelector(`[data-result="${nextItemId}"]`);
			if (nextItem) {
				nextItem.classList.add(`${className}-active`);
			}
		});
	});
}
